import { create } from '@storybook/theming/create';

export default create({
  base: 'dark',
  brandTitle: 'reakeys',
  brandUrl: 'https://github.com/reaviz/reakeys'
});
